"use client";

import { useHydrated } from "@trydig/ui/hooks";
import { useGeo } from "@/i18n/routing";

export interface ArticlePublishedAtProps {
	publishedAt: string;
}

const formatPublishedAt = (dateString: string, geo: string) => {
	const date = new Date(dateString);
	return new Intl.DateTimeFormat(geo, {
		day: "2-digit",
		month: "long",
		year: "numeric",
	}).format(date);
};

export const ArticlePublishedAt = ({
	publishedAt,
}: ArticlePublishedAtProps) => {
	const geo = useGeo();
	const hydrated = useHydrated();

	if (!hydrated) return <span />;

	return <span>{formatPublishedAt(publishedAt, geo.geo)}</span>;
};
